// routes
import { PATH_BranchSecretaryUser, PATH_HelpAndCommunication } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AppCache from '../../../services/appcache';
// ---------------------------------------------------------------------------------------------------

const icon = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
    dashboard: icon('ic_dashboard'),
    dataUpload: icon('ic_dataupload'),
    //  dataMapping: icon('ic_mapping'),
    //  noneligibleRecords: icon('ic_noneligible'),
    //  enablereupload: icon('ic_reupload'),
    //  dealerrequest: icon('ic_request'),
    helpdesk: icon('communication'),
    master: icon('ic_master'),
    report: icon('ic_chart'),
};

const isHnCActive = AppCache?.GetCurrentLoggedInUser()?.IsHnCActive;

const navConfig = [
    //   GENERAL
    //   ---------------------------------------------------------------------------------------------
    {
        items: [
            { title: 'Dealer Sales Upload', path: PATH_BranchSecretaryUser.dataUploadApprove, icon: ICONS.dataUpload },
            // { title: 'My Dealers Dashboard', path: PATH_BranchSecretaryUser.dealerlistpage, icon: ICONS.dashboard },
            // { title: 'Help and Communication', path: PATH_HelpAndCommunication.helpandcommunication('JJ Core'), opneinnewtab: true, icon: ICONS.helpdesk },
            {
                title: 'Masters', path: PATH_BranchSecretaryUser.readonlymaster.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor', path: PATH_BranchSecretaryUser.readonlymaster.distributor },
                    { title: 'Products', path: PATH_BranchSecretaryUser.readonlymaster.product },
                    { title: 'Accounts', path: PATH_BranchSecretaryUser.readonlymaster.account },
                    { title: 'Surgeons', path: PATH_BranchSecretaryUser.readonlymaster.surgeon },
                    { title: 'Employee Territory', path: PATH_BranchSecretaryUser.readonlymaster.empterritory },
                    { title: 'Territory Management', path: PATH_BranchSecretaryUser.readonlymaster.accountterritory },
                ],
            },
            {
                title: 'Report', path: PATH_BranchSecretaryUser.report.root, icon: ICONS.report,
                children: [
                    { title: 'Dealer Data Status Report', path: PATH_BranchSecretaryUser.report.dealerdatastatusreportpage },
                    { title: 'Dealer Reported Sales', path: PATH_BranchSecretaryUser.report.transactionreportpage },
                    { title: 'Dealer Reported SNS', path: PATH_BranchSecretaryUser.report.dealerreportedsnsreportpage },
                    { title: 'Dealer Price Report', path: PATH_BranchSecretaryUser.report.dealerreportpage },
                    { title: 'My Sales Report', path: PATH_BranchSecretaryUser.report.salesreportpage },
                    { title: 'Request Report', path: PATH_BranchSecretaryUser.report.ytddumpreportpage },
                ],
            },
        ],
    }
];
export default navConfig;